import { CommunicationResource } from "../locales";

export const communication: CommunicationResource = {
    digitalMaterial: "Digitales Material",
    tastings: "Kostproben",
    storeMaterial: "Marktmaterial",
    campaignMaterial: "Kampagnenmaterial",
    news: "News",
};
